import { SvgIcon, SvgIconProps } from '@mui/material';

import './ccf-call-commit-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfCallCommitIconProps extends SvgIconProps  {}

/**
 * Component displays call  commit  svg icon 
 * @param props -CcfCallCommitIconProps
 * @returns commit svg icon
 * @example - <CcfCallCommitIcon/>
 */
export function CcfCallCommitIcon(props: CcfCallCommitIconProps) {
  return (
    <SvgIcon {...props}>
    <g id="Commit" >
    <g id="Group_118187" data-name="Group 118187" transform="translate(-576 -209)">
      <g id="Rectangle_80258" data-name="Rectangle 80258" transform="translate(574 207)" fill="#526b7a" stroke="#707070" strokeWidth="1" opacity="0">
      <rect width="24" height="24" stroke="none"/>
        <rect x="0.5" y="0.5" width="23" height="23" fill="none"/>
      </g>
      <g id="Group_118198" data-name="Group 118198" transform="translate(577.318 209)">
        <g id="schedule-new-commitment">
          <path id="Path_13262" data-name="Path 13262" d="M-32.435-78.058a.948.948,0,0,0,.948-.948v-3.046A.948.948,0,0,0-32.435-83a.948.948,0,0,0-.948.948v3.046A.948.948,0,0,0-32.435-78.058Z" transform="translate(44.891 83)"/>
          <path id="Path_13263" data-name="Path 13263" d="M-25.869-80.985h-1.245v1.292a2.376,2.376,0,0,1-2.373,2.373,2.376,2.376,0,0,1-2.373-2.373v-1.292h-2.953v1.292a2.376,2.376,0,0,1-2.373,2.373,2.376,2.376,0,0,1-2.373-2.373v-1.292h-1.209A1.231,1.231,0,0,0-42-79.754v14.847a1.231,1.231,0,0,0,1.231,1.231h14.9a1.231,1.231,0,0,0,1.231-1.231V-79.754A1.231,1.231,0,0,0-25.869-80.985Zm-.717,14.959a.41.41,0,0,1-.41.41H-39.655a.41.41,0,0,1-.41-.41v-7.718h13.479Z" transform="translate(42 83.676)"/>
          <path id="Path_13264" data-name="Path 13264" d="M-38.166-78.058a.948.948,0,0,0,.948-.948v-3.046A.948.948,0,0,0-38.166-83a.948.948,0,0,0-.948.948v3.046A.948.948,0,0,0-38.166-78.058Z" transform="translate(42.968 83)"/>
        </g>
        <path id="commitPlus" d="M8.355,6.033H6.613V4.29a.29.29,0,1,0-.581,0V6.033H4.29a.29.29,0,1,0,0,.581H6.033V8.355a.29.29,0,0,0,.581,0V6.613H8.355a.29.29,0,0,0,0-.581Z" transform="translate(2.358 7.181)" fill="#526b7a" stroke="#526b7a" strokeWidth="1"/>
      </g>
    </g>
  </g>
    </SvgIcon>
  );
}

export default CcfCallCommitIcon;
